/*
 * Project: bellcloud
 * File: packages/types/device/mini/file_type.ts
 * Author: SWAN
 * Created: 2025-01-XX
 * Description: MINI 로그 파일 타입 정의
 */

export enum MiniFileType {
  DATALOG = 0, // Contains Gas Reading (log_type 0x01, 0x02), Event (log_type 0x03), Configuration (log_type 0x04)
  EVENTLOG = 1, // Gas alarm events only (separate from DATALOG)
  CAL_BUMP = 2, // Calibration/Bump log only (separate from DATALOG)
  SENSOR_CONFIG = 3, // Sensor config data (내부 사용, UI에 표시 안 함)
}
